import { render, staticRenderFns } from "./RequestAdditionalInformation.vue?vue&type=template&id=4b11213c&scoped=true"
import script from "./RequestAdditionalInformation.vue?vue&type=script&lang=js"
export * from "./RequestAdditionalInformation.vue?vue&type=script&lang=js"
import style0 from "./RequestAdditionalInformation.vue?vue&type=style&index=0&id=4b11213c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b11213c",
  null
  
)

export default component.exports